import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import { Link } from "gatsby";

const CardComponent = ({image, heading, description, hoverDescription, frontUrl, headingUrl, shadow, noBackground}) => {
  const cssClass = `card ${shadow && 'shadow'} ${noBackground && 'no-background'}`
  return (
    <div className="card-component-wrapper">
      <Card className={cssClass}>
        <img className="image" src={image} alt={heading}/>
        {headingUrl ?<Link to={headingUrl} className="heading-link"><h3 className='heading medium-font'>{heading}</h3></Link>
        :
        <h3 className='heading medium-font'>{heading}</h3>}
        <h4 className='description small-font'>{description}</h4>
        {frontUrl && (<Button size="small"  className="button-base clear-button small-font" href={frontUrl} target="blank">
            Read more
        </Button>)}
        {hoverDescription && (<div className="hover-text">
          <p className='description small-font'>{hoverDescription}</p>
          <Button size="small"  className="button-base clear-button small-font">
              Read more
          </Button>
        </div>)}
      </Card>
    </div>
  );
};

CardComponent.propTypes = {
  image: PropTypes.any,
  heading: PropTypes.string,
  description: PropTypes.string,
  onClick: PropTypes.func,
  shadow: PropTypes.bool,
  noBackground: PropTypes.bool,
  frontUrl: PropTypes.string,
  hoverDescription: PropTypes.string,
  headingUrl: PropTypes.string,
}

export default CardComponent;